/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileRefInputSchema } from './FileRefInputSchema';
import {
    FileRefInputSchemaFromJSON,
    FileRefInputSchemaFromJSONTyped,
    FileRefInputSchemaToJSON,
} from './FileRefInputSchema';
import type { JobFileSchema } from './JobFileSchema';
import {
    JobFileSchemaFromJSON,
    JobFileSchemaFromJSONTyped,
    JobFileSchemaToJSON,
} from './JobFileSchema';

/**
 * 
 * @export
 * @interface CreateBatchJobSchema
 */
export interface CreateBatchJobSchema {
    /**
     * 
     * @type {string}
     * @memberof CreateBatchJobSchema
     */
    workspace: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBatchJobSchema
     */
    userCommand: string;
    /**
     * 
     * @type {Array<JobFileSchema>}
     * @memberof CreateBatchJobSchema
     */
    userFiles: Array<JobFileSchema>;
    /**
     * 
     * @type {Array<FileRefInputSchema>}
     * @memberof CreateBatchJobSchema
     */
    userFileRefs?: Array<FileRefInputSchema>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBatchJobSchema
     */
    pipeToFiles?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateBatchJobSchema
     */
    taskArray?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof CreateBatchJobSchema
     */
    taskArrayNtasks?: number;
    /**
     * 
     * @type {Array<{ [key: string]: string; }>}
     * @memberof CreateBatchJobSchema
     */
    taskMapEnvVarsAndVals?: Array<{ [key: string]: string; }>;
    /**
     * 
     * @type {string}
     * @memberof CreateBatchJobSchema
     */
    taskMapEnvVar?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBatchJobSchema
     */
    taskMapEnvVals?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateBatchJobSchema
     */
    schedulerTaskArray?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBatchJobSchema
     */
    runOnScheduler?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBatchJobSchema
     */
    runOnWorkers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBatchJobSchema
     */
    runInContainer?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreateBatchJobSchema
     */
    envVars?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreateBatchJobSchema
     */
    secretEnvVars?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CreateBatchJobSchema
     */
    workdir?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBatchJobSchema
     */
    hostSetup?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateBatchJobSchema
     */
    jobTimeoutSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateBatchJobSchema
     */
    maxRetries?: number;
}

/**
 * Check if a given object implements the CreateBatchJobSchema interface.
 */
export function instanceOfCreateBatchJobSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "workspace" in value;
    isInstance = isInstance && "userCommand" in value;
    isInstance = isInstance && "userFiles" in value;

    return isInstance;
}

export function CreateBatchJobSchemaFromJSON(json: any): CreateBatchJobSchema {
    return CreateBatchJobSchemaFromJSONTyped(json, false);
}

export function CreateBatchJobSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBatchJobSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workspace': json['workspace'],
        'userCommand': json['user_command'],
        'userFiles': ((json['user_files'] as Array<any>).map(JobFileSchemaFromJSON)),
        'userFileRefs': !exists(json, 'user_file_refs') ? undefined : ((json['user_file_refs'] as Array<any>).map(FileRefInputSchemaFromJSON)),
        'pipeToFiles': !exists(json, 'pipe_to_files') ? undefined : json['pipe_to_files'],
        'taskArray': !exists(json, 'task_array') ? undefined : json['task_array'],
        'taskArrayNtasks': !exists(json, 'task_array_ntasks') ? undefined : json['task_array_ntasks'],
        'taskMapEnvVarsAndVals': !exists(json, 'task_map_env_vars_and_vals') ? undefined : json['task_map_env_vars_and_vals'],
        'taskMapEnvVar': !exists(json, 'task_map_env_var') ? undefined : json['task_map_env_var'],
        'taskMapEnvVals': !exists(json, 'task_map_env_vals') ? undefined : json['task_map_env_vals'],
        'schedulerTaskArray': !exists(json, 'scheduler_task_array') ? undefined : json['scheduler_task_array'],
        'runOnScheduler': !exists(json, 'run_on_scheduler') ? undefined : json['run_on_scheduler'],
        'runOnWorkers': !exists(json, 'run_on_workers') ? undefined : json['run_on_workers'],
        'runInContainer': !exists(json, 'run_in_container') ? undefined : json['run_in_container'],
        'envVars': !exists(json, 'env_vars') ? undefined : json['env_vars'],
        'secretEnvVars': !exists(json, 'secret_env_vars') ? undefined : json['secret_env_vars'],
        'workdir': !exists(json, 'workdir') ? undefined : json['workdir'],
        'hostSetup': !exists(json, 'host_setup') ? undefined : json['host_setup'],
        'jobTimeoutSeconds': !exists(json, 'job_timeout_seconds') ? undefined : json['job_timeout_seconds'],
        'maxRetries': !exists(json, 'max_retries') ? undefined : json['max_retries'],
    };
}

export function CreateBatchJobSchemaToJSON(value?: CreateBatchJobSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'workspace': value.workspace,
        'user_command': value.userCommand,
        'user_files': ((value.userFiles as Array<any>).map(JobFileSchemaToJSON)),
        'user_file_refs': value.userFileRefs === undefined ? undefined : ((value.userFileRefs as Array<any>).map(FileRefInputSchemaToJSON)),
        'pipe_to_files': value.pipeToFiles,
        'task_array': value.taskArray,
        'task_array_ntasks': value.taskArrayNtasks,
        'task_map_env_vars_and_vals': value.taskMapEnvVarsAndVals,
        'task_map_env_var': value.taskMapEnvVar,
        'task_map_env_vals': value.taskMapEnvVals,
        'scheduler_task_array': value.schedulerTaskArray,
        'run_on_scheduler': value.runOnScheduler,
        'run_on_workers': value.runOnWorkers,
        'run_in_container': value.runInContainer,
        'env_vars': value.envVars,
        'secret_env_vars': value.secretEnvVars,
        'workdir': value.workdir,
        'host_setup': value.hostSetup,
        'job_timeout_seconds': value.jobTimeoutSeconds,
        'max_retries': value.maxRetries,
    };
}

